import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const branches = new RepositoryFactory('branch');

export default {
  namespaced: true,
  state: {
    // Single user
    branch: {},
    branches: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
    createError: '',
    deleteError: false,
    updateError: false,
  },
  getters: {
    getBranch(state) {
      return state.branch;
    },
    getBranches(state) {
      for (const iterator of state.branches) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');

        const updatedAt = new Date(iterator.updatedAt);
        iterator.updatedAt = updatedAt.toLocaleDateString('pt-BR');
      }

      return state.branches.map((s) => ({
        id: s.id,
        name: s.name,
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
        classes: s.classes,
      }));
    },
    getBranchesTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
    getError(state) {
      return state.error;
    },
    getCreateError(state) {
      if (state.createError) {
        return state.createError.message;
      } else {
        return '';
      }
    },
  },
  mutations: {
    SET_BRANCH(state, data) {
      state.branch = data;
    },
    SET_BRANCHES(state, data) {
      state.branches = data.items;
      state.total = data.totalOfItems;
      // state.itemCount = data.itemCount;
      state.totalPages = data.pageCount;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_ALL_BRANCHES(state, data) {
      state.branches = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_CREATE_ERROR(state, error) {
      state.createError = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getBranches');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getBranches');
    },
    searchBranch: async ({ commit }, search) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await branches.getWithSearch(search);
        commit('SET_BRANCHES', data);
        commit('SET_PAGE', page);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    resetCreateError: ({ commit }) => {
      commit('SET_CREATE_ERROR', null);
    },
    createBranch: async ({ commit, dispatch }, payload) => {
      commit('SET_CREATE_ERROR', '');
      try {
        await branches.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Ramo criado com sucesso!',
        });
        dispatch('getBranches');
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
        commit('SET_CREATE_ERROR', error.response.data);
      }
    },
    deleteBranch: async ({ dispatch }, id) => {
      try {
        const { data } = await branches.delete(id);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Ramo excluído com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getBranches');
    },
    updateBranch: async ({ dispatch }, payload) => {
      try {
        await branches.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Ramo atualizado com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getBranches');
    },
    getBranchById: async ({ commit }, id) => {
      try {
        const { data } = await branches.getById(id);
        commit('SET_BRANCH', data);
      } catch (error) {}
    },
    getBranches: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await branches.get(state.currentPage);
        commit('SET_BRANCHES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getBranchesNoPaginate: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await branches.get();
        commit('SET_BRANCHES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getBranchesNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await branches.get();
        commit('SET_ALL_BRANCHES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
